/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentTypeResponse {
    getFixupPrototypeFunction() { return AgentTypeResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentTypeResponse>): AgentTypeResponse {
        let obj = Object.assign(new AgentTypeResponse(), model);
        AgentTypeResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentTypeResponse>): AgentTypeResponse {
        if (!model) return null;
        return AgentTypeResponse.newInstance(<AgentTypeResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentTypeResponse) {
        if (!obj) return;

        models.AgentTypeResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentTypeResponse): boolean {
        Object.setPrototypeOf(obj, AgentTypeResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.agent_types) {
            for (let val of this.agent_types) {
                models.AgentType.fixupPrototype(val);
            }
        }
    }

    /**
     * List of agent types
     */
    agent_types: Array<models.AgentType>;

}
